export default {
  // 新增雇员
  employeesInformationAdd: "/payroll/employeesInformation/add",
  // 展示雇员信息
  employeesInformationShow: "/payroll/employeesInformation/show",
  // 展示详情
  employeesInformationDetail: "/payroll/employeesInformation/detail",
  // 删除雇员
  employeesInformationDelete: "/payroll/employeesInformation/delete",  
  // 修改雇员信息
  employeesInformationUpdate: "/payroll/employeesInformation/update",
  // 职位名称下拉框数据(仅在线数据)
  employmentTitleDropdown: "/settings/employmentTitle/dropdown",
  // 职位名称下拉框数据(仅在线数据)
  employeesTimeAllowanceDropdown: "/settings/employeesTimeAllowance/dropdown",
  // account 获取人员数据
  employmentTitleAccount: "/account/searchAccountEmail",
  // 文件上传
  employmentUploadCommonFile: "/file/uploadCommonFile",
  // 文件删除
  employmentDelFile: "/payroll/employeesInformation/delFile",
  // 展示详情
  employeesInformationDetailView: "/payroll/employeesInformation/detail/view",
    // 展示详情
  employeesInformationDetailPropView: "/payroll/employeesInformation/detail/prop/view",
  // 根据accountId修改prop和group
  employeesInformationUpdateAccount: "/payroll/employeesInformation/updateAccount",
  // 根据accountId修改prop
  employeesInformationUpdateAccountProp: "/payroll/employeesInformation/updateAccountProp",
  // 根据accountId修改group
  employeesInformationUpdateAccountGroup: "/payroll/employeesInformation/updateAccountGroup",
  // 根据employeeId获取剩余的年假或病假时间
  getEmployeeIdLeave:"/sick/leave/getLeavel",
  // 提交病假申请
  getInsertSickLeave:"/sick/leave/insertSickLeave",
  //提交年假申请
  getInsertAnnualLeave:"/annual/leave/insertAnnualLeave"
};
